import { Container, Divider, Grid2 } from '@mui/material';
import { ImageContextProvider } from '../../imageContext';
import { ImageList } from '../ImageList';
import { ImageDetail } from '../ImageDetail';
import Popup from '../Popup';
import { ImageStructureDetail } from '../ImageStructureDetail';
import LoadingSpinner from '../LoadingSpinner';
import { PopupContextProvider } from '../../PopupContext';

export const ImageManagement = (): JSX.Element => {
  return (
    <>
      <ImageContextProvider>
        <PopupContextProvider>
          <LoadingSpinner />
          <Divider sx={{ backgroundColor: '#FFFFFF', height: '5px', color: '#FFFFFF' }} />
          <Container
            sx={{
              paddingLeft: 0,
              paddingRight: 0,
              maxWidth: 'none !important',
              height: '20px',
            }}
          >&nbsp;</Container>
          <Grid2 size={12} container spacing={2} p={2} bgcolor="#F3F6FE" borderRadius={4} margin={'10px'}>
            <Grid2 size={8}>
              <ImageList />
            </Grid2>
            <Grid2 size={4}>
              <Grid2>
                <ImageDetail />
              </Grid2>
              <Grid2>
                <br />
                <div>
                  <hr
                    style={{
                      border: 0,
                      borderTop: '1px solid #d3d3d3',
                      margin: 0,
                      width: '100%',
                    }}
                  />
                </div>
                <br />
                <ImageStructureDetail />
              </Grid2>
            </Grid2>
          </Grid2>

          <Popup initialTrigger={false} />
        </PopupContextProvider>
      </ImageContextProvider>
    </>
  );
};
